module.exports = __webpack_public_path__ + "static/img/settle-bc2.bac29cf0.png";